import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import { useNavigate } from 'react-router-dom';
// import "./ResultChart.css";
import "../FinalPage/FinalPage.css";
import "./DarkResult.css"
import {
    Chart,
    RadarController,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
} from 'chart.js';




import { faListDropdown } from "@fortawesome/free-solid-svg-icons";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router-dom";
import axios from "axios";
import Subscriptions from "../Subscriptions/Subscriptions";
import "./DarkResult.css"
import Dashboard from '../Dashboard/Dashboard'
import dark from "../../images/dark.png"
import black from "../../images/black.png"
import darkstand from "../../images/dark-stand.png"
import darksit from "../../images/dark-sit.png"
import { END_URL, IMG_URL } from "../../config";
import ProgressBarNew from '../ProgressBarNew/ProgressBarNew';
import ResultTwo from '../ResultTwo/ResultTwo'
import ResultPageLast from '../ResultPageLast/ResultPageLast';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import ResultChart from '../ResultChart/ResultChart';
import loadimg from "../../images/pp-logo.gif"; 
import SideResult from '../SideArche/SideResult';
import asm from "../../images/ann.png";
import ResultSlider from '../ResultSlider/ResultSlider';
import { Helmet } from 'react-helmet';
import { useLocation } from "react-router-dom";
import CalculateArchetype from "../CalculateArchetype/CalculateArchetype";
import GradientSlider from "../GradientSlider/GradientSlider";
import { Doughnut } from "react-chartjs-2";
import DoughnutLinearChart from "../DoughnutLinearChart/DoughnutLinearChart";
import ky from "../../images/key11.svg";
import sy from "../../images/weight.svg"
import sy1 from "../../images/stariconnew.svg"

function DarkResult({ plan, onLoginChange, result, testdata, demension, globaltest,userdetail ,admin }) {

    const [IsAdmin, setIsAdmin] = useState(admin);

    const location = useLocation();

    const isCalculatingMode = location.search.includes("calculating");

    const globaltestDark = globaltest?.globalTest || [];

    const chartRef = useRef(null);

    const contentRefs = useRef([]);

    const subAd = true;

    const [subscription, setSubscription] = useState(null);

    const [ShowModal, setShowModal] = useState(false);

    const [TestLink,setTestLink] = useState(null);

    const [TestLink1,setTestLink1] = useState(null);

    const [TestLink2,setTestLink2] = useState(null);

    const [calculationLoaded, setCalculationLoaded] = useState(true);
    
    const [RareDate,setRareDate] = useState([]); 

    const handleFocus = useCallback((index) => {

        isManualScrollRef.current = true;

        const targetElement = contentRefs.current[index];
        if (targetElement) {
            try {
                // Calculate position with 120px offset from top
                const elementTop = targetElement.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementTop - 120; // 120px below from head

                // Use window.scrollTo for precise control
                window.scrollTo({
                    top: Math.max(0, offsetPosition), // Ensure we don't scroll above page top
                    behavior: 'smooth'
                });

            } catch (error) {
                console.warn('Scroll with offset failed, using fallback:', error);
                // Fallback scroll method
                try {
                    const elementTop = targetElement.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
                    const offsetPosition = elementTop - 120;

                    if (window.scrollTo) {
                        window.scrollTo({
                            top: Math.max(0, offsetPosition),
                            behavior: 'smooth'
                        });
                    } else {
                        // Very old browser fallback
                        document.documentElement.scrollTop = Math.max(0, offsetPosition);
                    }
                } catch (fallbackError) {
                    console.error('All scroll methods failed:', fallbackError);
                }
            }
        }

        // Reset manual scroll flag after delay
        setTimeout(() => {
            isManualScrollRef.current = false;
        }, 1500);
    }, []);

  
    const subS = false;

    const { slug, test_slug } = useParams();

    const [ButtonLoad, setButtonLoad] = useState(false);

    const LocalTest = JSON.parse(localStorage.getItem(slug));

    const [testData, settestData] = useState([]);

    const [Result, setResult] = useState('');

    const [Demension, setDemension] = useState([]);

    const [Cluster, setCluster] = useState([]);

    const [getBladge, setgetBladge] = useState({});

    const [BladgeDimension, setBladgeDimension] = useState([]);

    const token = localStorage.getItem('token');
    const [selectedLabel, setSelectedLabel] = useState(null);
    const [selectedPercentage, setSelectedPercentage] = useState(null);
    const navigate = useNavigate();
    const user = localStorage.getItem('user');
    const [TestData, setTestData] = useState(testdata);
    const [SubPlan, setSubPlan] = useState({});

    const [hasSubscription, setHasSubscription] = useState(false);

    const [testMutiple, settestMutiple] = useState(false);

    const [hasplan, setHasPlan] = useState({});
    const [resultDetails, setResultDetails] = useState([]);

    const [ChartLabel, setChartLabel] = useState([]);


    const TestSaved = localStorage.getItem(`test_${LocalTest?.test?.id}`);
    const canvasRef = useRef(null);


    const [Opacity, setOpacity] = useState(true);

    const [Subcription, setSubcription] = useState([]);

    const [TestSubcription, setTestSubcription] = useState([]);

    const [TestResut, setTestResut] = useState([]);

    const [SavedTest, setSavedTest] = useState(false);

    const [resultReady, setResultReady] = useState(false);

    const [isLoading, setIsLoading] = useState(true);

    const [HavePastTest, setHavePastTest] = useState(false);

    const TestDone = useRef(null);

    const result_letter = useMemo(() => {
        return testData?.data?.map((item) => ({
            final_letter: item.letter === 'left' ? item.leftletter : item.rightletter,
        })) || [];
    }, [testData]);


    const [TestInfo, setTestInfo] = useState(() => {
        const saved =
        localStorage.getItem(
            `calculation_${slug}`
        );

        return saved
        ? JSON.parse(saved)
        : [];
    });

    useEffect(() => {

        setTestData(testdata);
    }, [testdata]);


    useEffect(() => {

        if (!SavedTest) {
            settestData(LocalTest);
        }

        if (SavedTest) {

            FetchResultData();
        }

    }, [SavedTest]);


    useEffect(() => {

        const SubcriptionDetail = async () => {

            try {

                const response = await axios.get(`${END_URL}/get-subcription`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                const reponsedata = response?.data;

                setSubcription(reponsedata);

            }
            catch {
                console.log('some error ');
            }

        };

        SubcriptionDetail();
    }

        , []);


    useEffect(() => {

        if (user) {

            SaveTest();
        }

        if (!user && !IsAdmin) {
            setTimeout(() => {

                window.scrollTo({ top: 0, behavior: 'smooth' });
                onLoginChange(true);
            }, 5000);
        }

        checkSubcription();

    }, [user, testData,IsAdmin]);

    const checkSubcription = async () => {

        try {

            const response = await axios.post(`${END_URL}/check-subcription`,
                { slug: slug },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                });

            const subcription = response.data.subcription;

            const plan = response.data.test_sub;

            setSubPlan(plan);
            if (subcription > 0) {
                setOpacity(false);
            }

            console.log('check subcription', subcription);
            console.log('Plan received from APIs:', plan);


        } catch (error) {

            console.error("Error sending result:", error);
        }

    };


    useEffect(() => {

        const checkSlugSubscription = async () => {
            try {
                const response = await axios.get(`${END_URL}/subscription/check/${slug}/${test_slug}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                setHasSubscription(response.data.has_subscription);

                settestMutiple(response.data.test_multiple);

                setHasPlan(response.data.plan);


            } catch (error) {
                setHasSubscription(false);
            }
        };

        checkSlugSubscription();
    }, [user, token]);


    const HandlePayment = (item) => {

        const InitializePayment = async () => {

            try {

                setButtonLoad(true);

                const response = await fetch(`${END_URL}/test-payment`, {

                    method: "POST",
                    headers: {

                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },

                    body: JSON.stringify(item)

                });

                const data = await response.json();

                console.log(data.payment, 'fetch data');


                if (data.payment) {

                    setButtonLoad(false);
                    window.location.href = data.payment;

                } else {

                    setButtonLoad(false);

                    console.error("Invalid response:", data);
                    alert("An error occurred while processing the request.");
                }

            } catch (error) {

                console.error("Error sending result:", error);
            }
        };

        InitializePayment();

    };




    const SaveTest = async () => {

        try {

            const response = await axios.post(`${END_URL}/submit/test/${slug}/${test_slug}`, LocalTest, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            const testsave = response?.data.saved;

            setTestLink2(response?.data?.subcription_popup);

            setSavedTest(testsave);

            setResult(response?.data?.result);

        } catch (error) {

            console.error("Error sending result:", error);
        }

    };

    useEffect(() => {
        if (Array.isArray(testData?.data) && testData?.data?.length > 0) {
            const chartfilter = testData?.data?.map((item) => ({
                label: item.letter === "left" ? item.leftlabel : item.rightlabel,
                percentage: item.letter === "left" ? item.left_result : item.right_result,
            }));

            setChartLabel(chartfilter);

            setSelectedLabel(chartfilter[0]?.label);
            setSelectedPercentage(Math.round(chartfilter[0]?.percentage));
        }

    }, [testData]);




    useEffect(() => {
        Chart.register(
            RadarController,
            RadialLinearScale,
            PointElement,
            LineElement,
            Filler,
            Tooltip,
            Legend
        );

        if (!canvasRef.current) return;
        const ctx = canvasRef.current.getContext('2d');

        if (chartRef.current) {
            chartRef.current.destroy();
        }

        chartRef.current = new Chart(ctx, {
            type: 'radar',
            data: {
                labels: ChartLabel?.map((item) => item.label),
                datasets: [{
                    data: ChartLabel?.map((item) => Math.round(item.percentage)),
                    backgroundColor: '#86a191',
                    borderColor: '#ffec8870',
                    borderWidth: 2,
                    pointBackgroundColor: '#ffec8870',
                    pointBorderColor: '#ffec8870'
                }]
            },
            options: {
                responsive: true,
                onClick: (event, elements) => {
                    if (elements.length > 0) {
                        const index = elements[0].index;
                        setSelectedLabel(ChartLabel[index].label);
                        setSelectedPercentage(Math.round(ChartLabel[index].percentage));
                    }
                },
                plugins: {
                    title: {
                        display: true,
                        text: "",
                        font: {
                            size: 18
                        },
                        color: '#657aed'
                    },
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: true
                    }
                },
                scales: {
                    r: {
                        angleLines: {
                            display: true
                        },
                        ticks: {
                            backdropColor: '#fff8d3',
                            color: '#6d6d6d'
                        },
                        suggestedMin: 0,
                        suggestedMax: 100
                    }
                }
            }
        });

        return () => {
            if (chartRef.current) {
                chartRef.current.destroy();
            }
        };
    }, [ChartLabel]);


    useEffect(() => {

        setIsLoading(true);

        FetchResultData();
    }, []);

    useEffect(() => {

        if (Demension && typeof Demension === 'object' && Object.keys(Demension).length > 0) {
            setResultReady(true);
        }
        if(test_slug =='start')
        {
            setResultReady(true);
        }
    }, [Demension,test_slug]);

        const handleNavigete = (link) => {
    
            if (link) {
            window.location.href = `/${link}`;
            }
        };


        const handleSub = async (subJson) => {

            try {

                setShowModal(true);

                let subIds = subJson;

                if (typeof subJson === "string") {
                try {
                    subIds = JSON.parse(subJson);
                } catch (e) {
                    console.error("Invalid JSON string for subIds:", e);
                    return;
                }
                }

                if (!Array.isArray(subIds) || subIds.length === 0) {
                console.warn("No valid subscription IDs found:", subIds);
                return;
                }

                const res = await axios.post(
                `${END_URL}/sub_adver`,
                { ids: subIds },
                {
                    headers: {
                    Authorization: `Bearer ${token}`,
                    },
                }
                );

                setSubscription(res.data);

            } catch (err) {

                console.error("Error loading subscriptions:", err);
            }
        };


    const FetchResultData = async () => {

        try {

            const response = await fetch(`${END_URL}/result-clusterdark/${slug}/${test_slug}`, {

                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                 body: JSON.stringify({
                    admin: IsAdmin ? true : false,
                }), 
            });

            const data = await response.json();

            const result = data?.data?.result_letter;

            // const test = {
            //     test: {
            //         id: data.test.id,
            //         name: data.test.name,
            //         type: data.test.type,
            //         slug: data?.test?.slug || "",
            //         test_slug: test_slug || "",
            //         result_test_name:  data.test.result_test_name || ""
            //     }
            // };


            // const resultdata = {

            //     data: data?.data?.map((item, index) => ({
            //         category_id: item.id,
            //         left_result: item.left_result,
            //         leftlabel: item.resultcategory.left_label,
            //         leftletter: item.resultcategory.leftletter,
            //         letter: item.letter,
            //         name: item.name,
            //         right_result: item.right_result,
            //         rightlabel: item.resultcategory.right_label,
            //         rightletter: item.resultcategory.rightletter,
            //     }))
            // };

            // const ConvertedtestData = {
            //     ...resultdata,
            //     result: result,
            //     ...test
            // };

            settestData({
                test: data.test,
                data: data.data,
                rarity_percentage:data.extest?.rarity_percentage,
            });

            setRareDate(data?.extest?.rarer_percentage);

            setDemension(data?.dimensions);

            setCluster(data.cluster);

            setgetBladge(data.bladge);

            setHavePastTest(data.have_past_test);

            setBladgeDimension(data.dimension_data);
            setResultDetails(data.result_details);

            setTestLink(data?.advertisment_image_link?.slug);

            setTestLink1(data?.paid_test_sub_button_link?.slug);

        } catch (error) {

            console.error("Error sending result:", error);
        }
        finally {

            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (Array.isArray(resultDetails) && resultDetails.length > 0) {
        setResultReady(true);
        }
    }, [resultDetails]);

    const testsubscription = testData?.test?.type;

    const typetest = testsubscription === 'free_test' ? 'type_1' : testsubscription;

    const subplan = Subcription?.data?.filter((item) => {
        return item.type === typetest;
    });

    console.log(subplan, 'Filtered subscription plan');

    const colors = ["purple", "#daa520", "#3fa8eb", "#19bbab", "#ff8183", "#b8f976"];

    const handleNavigate = (url) => {

        navigate(`${url}`);
    };


    const sideResultRef = useRef(null);

    const observerRef = useRef(null);

    const isManualScrollRef = useRef(false);


    useEffect(() => {
        // Cleanup existing observer
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }

        if (!resultDetails?.length) return;

        // Clear existing refs array
        contentRefs.current = [];

        // Wait for DOM to be ready
        const setupObserver = () => {
            try {
                // Find all content elements
                const elementsToObserve = document.querySelectorAll('.final-part1');

                if (!elementsToObserve.length) {
                    console.warn('No .final-part1 elements found');
                    return;
                }

                // Create intersection observer with production-safe options
                const observer = new IntersectionObserver(
                    (entries) => {
                        if (isManualScrollRef.current) return; // Skip during manual scrolling

                        let visibleEntry = null;
                        let maxRatio = 0;

                        // Find the most visible entry
                        entries.forEach((entry) => {
                            if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
                                maxRatio = entry.intersectionRatio;
                                visibleEntry = entry;
                            }
                        });

                        // Update active index for most visible element
                        if (visibleEntry) {
                            try {
                                const index = parseInt(visibleEntry.target.dataset.index, 10);
                                if (!isNaN(index) && index >= 0) {
                                    // Use setTimeout to ensure smooth updates
                                    setTimeout(() => {
                                        if (sideResultRef.current?.setActiveIndex && !isManualScrollRef.current) {
                                            sideResultRef.current.setActiveIndex(index);
                                        }
                                    }, 50);
                                }
                            } catch (error) {
                                console.warn('Error processing intersection entry:', error);
                            }
                        }
                    },
                    {
                        root: null,
                        rootMargin: '-20% 0px -60% 0px',
                        threshold: [0, 0.1, 0.25, 0.5, 0.75, 1.0] // Multiple thresholds for better detection
                    }
                );

                // Observe all content elements
                elementsToObserve.forEach((el, idx) => {
                    if (el && el.nodeType === Node.ELEMENT_NODE) {
                        // Ensure data-index is set
                        el.setAttribute('data-index', idx.toString());
                        observer.observe(el);
                        contentRefs.current[idx] = el;
                    }
                });

                observerRef.current = observer;

                console.log(`Observing ${elementsToObserve.length} elements`);

            } catch (error) {
                console.error('Error setting up intersection observer:', error);
            }
        };

        // Setup observer after a small delay to ensure DOM is ready
        const timeoutId = setTimeout(setupObserver, 100);

        return () => {
            clearTimeout(timeoutId);
            if (observerRef.current) {
                observerRef.current.disconnect();
                observerRef.current = null;
            }
        };
    }, [resultDetails]);

    useEffect(() => {
        return () => {
            if (observerRef.current) {
                observerRef.current.disconnect();
            }
        };
    }, []);


    const handleSliderImageLoaded = () => {
        setResultReady(true);
    };

    const sideclass = "side-bar-dark";





    const [scollClass, setscollClass] = useState("");
    // small screen side bar script.........

    const [isOpen, setIsOpen] = useState(false);
    const sidebarRef = useRef(null);

    const handleToggle = () => {
        setIsOpen((prev) => !prev);
    };

    // Close on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                sidebarRef.current &&
                !sidebarRef.current.contains(event.target) &&
                !event.target.closest(".menu-toggleBar")
            ) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const [tierData, setTierData] = useState([]);
  
    useEffect(() => {

    const fetchTiers = async () => {

        try {

        const res = await fetch(`${END_URL}/trait-tiers`);

        const data = await res.json();

        setTierData(data);
        } catch (err) {

        console.error("Failed to load tier data", err);
        }
    };

    fetchTiers();
    }, []);


    const [timeoutPassed, setTimeoutPassed] = useState(false);

     useEffect(() => {
          const timer = setTimeout(() => {
            setTimeoutPassed(true);
          }, 8000);
    
          return () => clearTimeout(timer);
      }, []);

    useEffect(() => {
        if (timeoutPassed) {
        navigate(location.pathname, { replace: true });
        }
    }, [timeoutPassed]);

    const dataReady = !isLoading && resultReady;

    const showCalculatingLoader = isCalculatingMode &&  (!calculationLoaded || !(timeoutPassed && dataReady));

    const showNormalLoader = !isCalculatingMode && !dataReady;

    if (showCalculatingLoader) {
      return (
        <CalculateArchetype token={token} slug={slug} test_slug={test_slug} TestInfo={TestInfo}  />
      );
    }

    if (showNormalLoader) {
      return (
        <div className="loader-container">
          <img src={loadimg} alt="Loading..." className="loader-gif" />
        </div>
      );
    }
    

    return (

    <>
        <Helmet>
                
                <meta property="og:image" content={`${IMG_URL}/d0/${Demension?.share_image}`} />

                <meta name="twitter:image" content={`${IMG_URL}/d0/${Demension?.share_image}`} />
                
        </Helmet>

        <div className="dark-main">

                <>
                    {Demension && Object.keys(Demension).length > 0 && (

                        Demension.banner_image ? (

                            <ResultSlider dimension={Demension} onImageLoadComplete={handleSliderImageLoaded} />

                        )

                            : (

                                <div className="container-fluid dark-fluid1">

                                    <div className="row">

                                        <div className="dark-col" style={{ backgroundColor: Demension?.bg_image }}></div>

                                        <div className="row dark-row">
                                            <div className="col-12 col-md-7">
                                                <h1>
                                                    {Demension?.name} <span>{Result?.split('').join(' ')}</span>
                                                </h1>
                                                <p>{Demension?.description}</p>
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <img src={`${IMG_URL}/d0/${Demension?.image}`} alt="" />
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            )
                    )}

                    <div className="container-fluid dark-fluid2 darkfluid-21">

                        <div className="row">

                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 das-res">

                            {!IsAdmin && (

                                <Dashboard globaltest={globaltest} />
                            )}


                                {resultReady && (

                                    <>

                                        {Demension?.advertisment_image && (

                                            <div className="adver-title">

                                                <a 
                                                
                                                    // href={`/${Demension?.advertisment_image_link}`} 

                                                    onClick={
                                                        TestLink != "" && TestLink != null
                                                            ? () => handleNavigete(TestLink)
                                                            : () => handleSub(Demension?.advertisment_image_link)
                                                    }
                                                    
                                                    className="adver-link">

                                                    <div className="dark-adverts">

                                                        <img loading="lazy" src={`${IMG_URL}/d0/${Demension?.advertisment_image}`} alt="" />

                                                    </div>

                                                </a>

                                            </div>
                                        )}

                                        {Demension?.advertisment_title && (

                                            <h5>{Demension?.advertisment_title}</h5>

                                        )}

                                        {resultDetails && resultDetails.length > 0 && resultDetails.filter(item => item.title !== "" && item.title !== null).length > 0 && (

                                            <SideResult ref={sideResultRef} onMenuItemClick={handleFocus} resultDetails={resultDetails} sideclass={sideclass} />
                                        )}
                                    </>
                                )}

                            </div>


                            <div className="col-12 col-sm-12 col-md-8 col-lg-8 dark-res">

                                <>
                                    <span className="menu-toggleBar" onClick={handleToggle}>
                                        <FontAwesomeIcon icon={faBars} />
                                    </span>


                                    {resultReady && (
                                        
                                        <div
                                            className={`common-sidebar ${isOpen ? "open" : ""}`}
                                            ref={sidebarRef}
                                        >
                                            <div className={`lsit-item-component ${isOpen ? "open" : ""}`}>
                                                {resultDetails && resultDetails.length > 0 && resultDetails.filter((item) => item.title).length > 0 && (
                                                    <SideResult
                                                        sideclass={scollClass}
                                                        ref={sidebarRef}
                                                        onMenuItemClick={(...args) => {
                                                            handleFocus(...args);
                                                            setIsOpen(false);
                                                        }}
                                                        resultDetails={resultDetails
                                                            .filter((item) => item.title)
                                                            .map((item, idx) => ({
                                                                ...item,
                                                                _index: idx,
                                                                _originalIndex: resultDetails.findIndex(
                                                                    (original) => original === item
                                                                ),
                                                            }))}
                                                    />
                                                )}
                                            </div>
                                        </div>

                                    )}


                                </>



                                <div className="dark-inner-outer">

                                    {test_slug === 'start' && (
                                        !isLoading ? (
                                            <>
                                                <div className="no-login-result">
                                                    {globaltestDark
                                                        .filter(item => item.slug === slug)
                                                        .map(item => (
                                                            <div key={item.slug} dangerouslySetInnerHTML={{ __html: item.description || '' }} />
                                                        ))
                                                    }

                                                        <a className="button"
                                                    
                                                            onClick={
                                                                TestLink2?.attend_test_subcription?.slug != "" && TestLink2?.attend_test_subcription?.slug != null
                                                                    ? () => handleNavigete(TestLink2?.attend_test_subcription?.slug)
                                                                    : () => handleSub(TestLink2?.subcription_link)
                                                            }
                                                        >

                                                            {TestLink2?.button_label} <span><FontAwesomeIcon className="icc" icon={faArrowRight} /></span>
                                                            
                                                        </a>
                                                       

                                                </div>
                                            </>
                                        ) : (
                                            <div className="loader-container">
                                                {/* <img src={loadimg} alt="Loading..." className="loader-gif" /> */}
                                            </div>
                                        )
                                    )}


                                    {resultDetails && resultDetails.length > 0 &&
                                        <>

                                            {/* <div className="dark-repeater final-col final-col-inner">
                                                {resultDetails?.map((item, index) => (

                                                    <div className={`final-part1 ${item.content_type}`} data-index={index} ref={(el) => { if (el && el.nodeType === Node.ELEMENT_NODE) { contentRefs.current[index] = el; } }} key={`content-${item.id || index}-${index}`} dangerouslySetInnerHTML={{ __html: item.content }} />
                                                ))}

                                            </div> */}

                                             <div className="final-col-inner">
                                                    {(() => {
                                                        const groupedElements = [];
                                                        let buffer = [];
                                                        let contentRefIndex = 0;

                                                        const isExtendSection = (classStr) =>
                                                        classStr.split(" ").includes("extend_section");

                                                        resultDetails.forEach((item, index) => {
                                                        const contentTypeClass = item.content_type
                                                            ? item.content_type
                                                            : "";

                                                        const contentDiv = (
                                                            <div
                                                            className={`final-part1 ${contentTypeClass}`}
                                                            ref={(el) => {
                                                                if (item.title && el) {
                                                                contentRefs.current[contentRefIndex] = el;
                                                                el.setAttribute(
                                                                    "data-index",
                                                                    contentRefIndex.toString()
                                                                ); // Use setAttribute for better compatibility
                                                                contentRefIndex++;
                                                                }
                                                            }}
                                                            key={item.id || index}
                                                            dangerouslySetInnerHTML={{ __html: item.content }}
                                                            />
                                                        );

                                                        if (isExtendSection(contentTypeClass)) {

                                                            buffer.push(contentDiv);


                                                        } else {
                                                            if (buffer.length > 0) {
                                                            groupedElements.push(
                                                                <div className="extend-common" key={`group-${index}`}>
                                                                {buffer}
                                                                </div>
                                                            );
                                                            buffer = [];
                                                            }

                                                            groupedElements.push(contentDiv);

                                                               if (index === 0 && Demension?.rarity_common) {
                                                            
                                                                    groupedElements.push(

                                                                        <>
                                                                            <div className="result-newDash2" key="rarity-common-section">
                                        
                                                                                <div className="result-newDash2-title">
                                                                                <span>
                                        
                                                                                    <img src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image1}`} alt="" />
                                                                                    
                                                                                </span>
                                                                                <div>
                                                                                    <h5> {Demension?.rarity_common?.rarity_section_title}</h5>
                                                                                    <p>
                                                                                        {Demension?.rarity_common?.rarity_section_description}
                                                                                    </p>
                                                                                </div>
                                                                                </div>
                                        
                                                                                <div className="result-newDash2-box" style={{"--color-border": Demension?.rarity_common?.rarity_post_color}} >
                                        
                                                                                    <div className="result-newDash2-b1">
                                                                                    <div>
                                                                                        <span style={{"--color-grade1":Demension?.rarity_common?.rarity_post_color, "--color-grade2":Demension?.rarity_common?.rarity_post_color}} >1</span>
                                        
                                                                                        <h5> 
                                        
                                                                                            {Demension?.rarity_common?.rare_type_title}
                                        
                                                                                        </h5>
                                        
                                                                                    </div>
                                                                                    <h3 style={{"--color-border":Demension?.rarity_common?.rarity_post_color}} >{RareDate?.percentage}%</h3>
                                        
                                                                                    <p style={{"--text-color":Demension?.rarity_common?.rarity_post_color}} >
                                        
                                                                                            {Demension?.rarity_common?.post_rarity_percentage?.replace(
                                                                                            "{percentage}",
                                                                                            (RareDate?.percentage || 0)
                                                                                            )}
                                                                                    </p>
                                        
                                                                                    {/* <h6>
                                                                                        {" "}
                                                                                        {Demension?.rarity_section?.post_rarity_description}
                                                                                    </h6> */}
                                        
                                                                                    </div>
                                        
                                                                                    <div className="result-newDash2-b2">
                                                                                    <div className="result-newDash2-chart">
                                                                                        <div class="circular-chart-newDash2">
                                                                                        <DoughnutLinearChart bg_color_2={`${Demension?.rarity_common?.rarity_post_color}4D`} gauge_color={Demension?.rarity_common?.rarity_post_color}  value={100 - RareDate?.percentage} gauge_title={Demension?.rarity_common?.graph_post_rarity_title} />
                                                                                        </div>
                                                                                        <div className="circular-chart-newDash2-bar" >
                                                                                        <GradientSlider  gauge_color1={Demension?.rarity_common?.rarity_post_color} gauge_color2={Demension?.rarity_common?.rarity_archetype_color} value={RareDate?.percentage}  />
                                                                                        </div>
                                        
                                                                                        {/* <p >
                                                                                            {Demension?.rarity_common?.post_percentage?.replace(
                                                                                                "{percentage}",
                                                                                                100 - (RareDate?.percentage || 0)
                                                                                            )}
                                                                                        </p> */}
                                        
                                                                                    </div>
                                                                                    <div className="result-newDash2-content">
                                                                                        <div className="result-newDash2-sub">
                                                                                        <div>
                                                                                            <span>
                                        
                                                                                            <img src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image1}`} alt="" />
                                        
                                                                                            </span>
                                                                                            <h5> {Demension?.rarity_section?.post_rarity_label}</h5>
                                                                                        </div>
                                                                                        <p>
                                                                                            {Demension?.rarity_section?.post_rarity_description}
                                                                                        </p>
                                                                                        </div>
                                                                                    </div>
                                                                                    </div>
                                        
                                                                                    {/* <div className="result-newDash2-b1 result-newDash2-b3"></div> */}
                                                                                </div>
                                        
                                                                                <div className="result-newDash2-box" style={{"--color-border":Demension?.rarity_common?.rarity_archetype_color}} >
                                        
                                                                                    <div className="result-newDash2-b1">
                                                                                    <div>
                                                                                        <span style={{"--color-grade1":Demension?.rarity_common?.rarity_archetype_color, "--color-grade2":Demension?.rarity_common?.rarity_archetype_color}} >2</span>
                                        
                                                                                        <h5> 
                                        
                                                                                            {Demension?.rarity_common?.rarity_title}
                                        
                                                                                        </h5>
                                        
                                                                                    </div>
                                                                                    
                                                                                        <h3  style={{"--color-border":Demension?.rarity_common?.rarity_archetype_color}} >{testData?.rarity_percentage}%</h3>
                                        
                                                                                        <p  style={{"--text-color":Demension?.rarity_common?.rarity_archetype_color}} >
                                        
                                                                                                {Demension?.rarity_common?.archetype_rarity_percentage?.replace(
                                                                                                "{percentage}",
                                                                                                (testData?.rarity_percentage || 0)
                                                                                                )} 
                                                                                        </p>
                                        
                                                                           
                                                                                    </div>
                                        
                                                                                    <div className="result-newDash2-b2">
                                        
                                                                                        <div className="result-newDash2-chart">
                                                                                        
                                                                                        <div class="circular-chart-newDash2">
                                                                                            <DoughnutLinearChart bg_color_2={`${Demension?.rarity_common?.rarity_archetype_color}4D`}  gauge_color={Demension?.rarity_common?.rarity_archetype_color}  value={100 -testData?.rarity_percentage} gauge_title={Demension?.rarity_common?.graph_archetype_rarity_title} />
                                                                                        </div>
                                                                                        <div className="circular-chart-newDash2-bar">
                                                                                            <GradientSlider gauge_color1={Demension?.rarity_common?.rarity_archetype_color} gauge_color2={Demension?.rarity_common?.rarity_post_color}  value={testData?.rarity_percentage}  />
                                        
                                                                                            
                                                                                        </div>
                                        
                                        
                                                                                        </div>
                                                                                        <div className="result-newDash2-content">
                                                                                        <div className="result-newDash2-sub">
                                                                                            <div>
                                                                                            <span>
                                                                                                <img src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image2}`} alt="" />
                                                                                            </span>
                                        
                                                                                            <h5> {Demension?.rarity_section?.archetype_rarity_label}</h5>
                                        
                                                                                            </div>
                                                                                            <p>
                                        
                                                                                            {Demension?.rarity_section?.archetype_rarity_description}
                                        
                                                                                            </p>
                                                                                        </div>
                                                                                        </div>
                                                                                    </div>
                                        
                                                                                </div>
                                        
                                                                                <div className="result-newDash2-weight">
                                                                                <div className="result-newDash2-weight-left">
                                                                                    <span><img src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image2}`} alt="" /></span>
                                        
                                                                                    <h6>  {Demension?.rarity_common?.key_diffence_type}</h6>
                                        
                                                                                </div>
                                        
                                                                                <div className="result-newDash2-weight-right">
                                        
                                                                                    <ul>
                                                                                        <li style={{"--color-two":Demension?.rarity_common?.rarity_post_color}}>{Demension?.rarity_common?.key_term_1}  </li>
                                                                                        <li style={{"--color-two":Demension?.rarity_common?.rarity_archetype_color}}>{Demension?.rarity_common?.key_term_2}</li>
                                                                                    </ul>
                                        
                                                                                </div>
                                                                                </div>
                                                                            </div>

                                                                            {testData?.test && <ResultChart resultRef={TestDone} onLoginChange={onLoginChange} past_test={HavePastTest} subplan={subplan} token={token} result={result_letter} testdata={testData} tierData={tierData} demension={Demension} opacity={Opacity} />}
                                                                            
                                                                        </>
                                                                    );
                                                                }
                                                        }
                                                        });

                                                        if (buffer.length > 0) {
                                                        groupedElements.push(
                                                            <div className="extend-common" key="group-end">
                                                            {buffer}
                                                            </div>
                                                        );
                                                        }

                                                        return groupedElements;
                                                    })()}

                                            </div>

                                            
                                            
                                             {/* {Demension?.rarity_common && (

                                                <div className="result-newDash2">

                                                    <div className="result-newDash2-title">
                                                    <span>

                                                        <img src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image1}`} alt="" />
                                                        
                                                    </span>
                                                    <div>
                                                        <h5> {Demension?.rarity_common?.rarity_section_title}</h5>
                                                        <p>
                                                            {Demension?.rarity_common?.rarity_section_description}
                                                        </p>
                                                    </div>
                                                    </div>

                                                    <div className="result-newDash2-box" style={{"--color-border": Demension?.rarity_common?.rarity_post_color}} >

                                                        <div className="result-newDash2-b1">
                                                        <div>
                                                            <span style={{"--color-grade1":Demension?.rarity_common?.rarity_post_color, "--color-grade2":Demension?.rarity_common?.rarity_post_color}} >1</span>

                                                            <h5> 

                                                                {Demension?.rarity_common?.rare_type_title}

                                                            </h5>

                                                        </div>
                                                        <h3 style={{"--color-border":Demension?.rarity_common?.rarity_post_color}} >{RareDate?.percentage}%</h3>

                                                        <p style={{"--text-color":Demension?.rarity_common?.rarity_post_color}} >

                                                                {Demension?.rarity_common?.post_rarity_percentage?.replace(
                                                                "{percentage}",
                                                                 (RareDate?.percentage || 0)
                                                                )}
                                                        </p>

                                        
                                                        </div>

                                                        <div className="result-newDash2-b2">
                                                        <div className="result-newDash2-chart">
                                                            <div class="circular-chart-newDash2">
                                                            <DoughnutLinearChart bg_color_2={`${Demension?.rarity_common?.rarity_post_color}4D`} gauge_color={Demension?.rarity_common?.rarity_post_color}  value={100 - RareDate?.percentage} gauge_title={Demension?.rarity_common?.graph_post_rarity_title} />
                                                            </div>
                                                            <div className="circular-chart-newDash2-bar" >
                                                            <GradientSlider  gauge_color1={Demension?.rarity_common?.rarity_post_color} gauge_color2={Demension?.rarity_common?.rarity_archetype_color} value={RareDate?.percentage}  />
                                                            </div>


                                                        </div>
                                                        <div className="result-newDash2-content">
                                                            <div className="result-newDash2-sub">
                                                            <div>
                                                                <span>

                                                                <img src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image1}`} alt="" />

                                                                </span>
                                                                <h5> {Demension?.rarity_section?.post_rarity_label}</h5>

                                                            </div>

                                                                {Demension?.rarity_section?.post_rarity_description}

                                                            </div>
                                                        </div>
                                                        </div>

                                                    </div>

                                                    <div className="result-newDash2-box" style={{"--color-border":Demension?.rarity_common?.rarity_archetype_color}} >

                                                        <div className="result-newDash2-b1">
                                                        <div>
                                                            <span style={{"--color-grade1":Demension?.rarity_common?.rarity_archetype_color, "--color-grade2":Demension?.rarity_common?.rarity_archetype_color}} >2</span>

                                                            <h5> 

                                                                {Demension?.rarity_common?.rarity_title}

                                                            </h5>

                                                        </div>
                                                        
                                                            <h3  style={{"--color-border":Demension?.rarity_common?.rarity_archetype_color}} >{testData?.rarity_percentage}%</h3>

                                                            <p  style={{"--text-color":Demension?.rarity_common?.rarity_archetype_color}} >

                                                                    {Demension?.rarity_common?.archetype_rarity_percentage?.replace(
                                                                    "{percentage}",
                                                                    (testData?.rarity_percentage || 0)
                                                                    )} 
                                                            </p>

                                                        </div>

                                                        <div className="result-newDash2-b2">

                                                            <div className="result-newDash2-chart">
                                                            
                                                            <div class="circular-chart-newDash2">
                                                                <DoughnutLinearChart bg_color_2={`${Demension?.rarity_common?.rarity_archetype_color}4D`}  gauge_color={Demension?.rarity_common?.rarity_archetype_color}  value={100 -testData?.rarity_percentage} gauge_title={Demension?.rarity_common?.graph_archetype_rarity_title} />
                                                            </div>
                                                            <div className="circular-chart-newDash2-bar">
                                                                <GradientSlider gauge_color1={Demension?.rarity_common?.rarity_archetype_color} gauge_color2={Demension?.rarity_common?.rarity_post_color}  value={testData?.rarity_percentage}  />

                                                                
                                                            </div>

                                    
                                                            </div>
                                                            <div className="result-newDash2-content">
                                                            <div className="result-newDash2-sub">
                                                                <div>
                                                                <span>
                                                                    <img src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image2}`} alt="" />
                                                                </span>

                                                                <h5> {Demension?.rarity_section?.archetype_rarity_label}</h5>

                                                                </div>
                                                                <p>

                                                                {Demension?.rarity_section?.archetype_rarity_description}

                                                                </p>
                                                            </div>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className="result-newDash2-weight">
                                                    <div className="result-newDash2-weight-left">
                                                        <span><img src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image2}`} alt="" /></span>

                                                        <h6>  {Demension?.rarity_common?.key_diffence_type}</h6>

                                                    </div>

                                                    <div className="result-newDash2-weight-right">

                                                        <ul>
                                                            <li style={{"--color-two":Demension?.rarity_common?.rarity_post_color}}>{Demension?.rarity_common?.key_term_1}  </li>
                                                            <li style={{"--color-two":Demension?.rarity_common?.rarity_archetype_color}}>{Demension?.rarity_common?.key_term_2}</li>
                                                        </ul>

                                                    </div>
                                                    </div>
                                                </div>
                                            )} */}

                                            {/* {RareDate && (

                                                <div className="result-newDash">

                                                    <div className="result-newDash-outer">
                                                    <div className="result-newDash-title"> 

                                                        <span>{Demension?.rare_type_title}</span>
                                                        
                                                        <h5>{RareDate?.heading?.replace('{percentage}', RareDate?.percentage)}</h5>
                                                        <p>
                                                        {RareDate?.description}
                                                        </p>
                                                    </div>

                                                    <div className="result-newDash-value-box">
                                                        <div className="result-newDash-value-box-inner">
                                                        <div className="per-value">
                                                            <p>Rarity Score</p>
                                                            <h2>{RareDate?.percentage}%</h2>
                                                        </div>
                                                        <button>{RareDate?.name}</button>
                                                        </div>

                                                        <div className="result-newDash-bar">
                                                        <div class="two-card-progress">
                                                            <div class="progress-bar-fill-repeat-title">
                                                            <span>{RareDate?.extreme_type}</span>
                                                            <div>Top {100 - RareDate?.percentage}%</div>
                                                            </div>
                                                            <div class="two-card-progress2">
                                                            <div class="progress-bar-fill-repeat"
                                                                style={{
                                                                        background: `linear-gradient(
                                                                            90deg,
                                                                            #8c30a8b5 ${100 - RareDate?.percentage}%,
                                                                            #cda632 40%
                                                                        )`,
                                                                    }}
                                                            ></div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>

                                                        <div className="result-newDash-textDiv">

                                                            <div dangerouslySetInnerHTML={{__html:RareDate?.matters}} />
                                                            
                                                            <div dangerouslySetInnerHTML={{__html:RareDate?.fallback}} />

                                                            <div dangerouslySetInnerHTML={{__html:RareDate?.dev_note}} />


                                                        </div>

                                                        <div className="result-newDash-textDiv rariry-result">

                                                                {Demension?.rarity_name && (
                                                                <div className="rarity-des result-newDash-title">

                                                                    <span>{Demension?.rarity_title}</span>
                                                                        <h5>{Demension?.rarity_name?.replace('{rarity}', testData?.rarity_percentage)}</h5>
                                                                        <p>{Demension?.rarity_description}</p>
                                                                </div>
                                                                )}
                                                        </div>

                                                    </div>

                                                </div>

                                            )} */}

                                            <ResultTwo badge={getBladge}  test_id={testData?.test?.id} />

                                            {/* <Subscriptions subs={subS} Subcription={Subcription} /> */}
                                        </>
                                    }

                                    {test_slug !== 'start' && (

                                        <div className='free-unpaid-res'>

                                            <ResultPageLast userdetail={userdetail} type="result" TestLink={TestLink1} onLoginChange={onLoginChange} token={token} payment={hasplan} slug={slug} demension={Demension} />

                                        </div>
                                    )}

                                </div>


                                <>

                                    {Demension?.advertisment_image && (

                                        <div className="adver-title med-767">

                                            <a href={`/${Demension?.advertisment_image_link}`} className="adver-link">

                                                <div className="dark-adverts">

                                                    <img loading="lazy" src={`${IMG_URL}/d0/${Demension?.advertisment_image}`} alt="" />

                                                </div>

                                            </a>

                                        </div>
                                    )}

                                </>



                            </div>

                        </div>

                    </div>


                    {ShowModal && (
                                            
                    <div 
                  className={`newdashpop-overlay subs-cognit-modal1 modal_subcript ${
                   subscription?.data?.length == 1 ? "single-subscription" : ""
                  }`}
                
                >

                            <div className="newdashpop-inner">

                                <div className="newdashpop-container">

                                    <button
                                        className="newdashpop-close"
                                        onClick={() => setShowModal(false)}
                                        >
                                        &times;
                                    </button>

                                    <div className="conent-pop">
                                    
                                    <Subscriptions subs={subAd} userdetail={userdetail} Subcription={subscription} onLoginChange={onLoginChange}/>

                                    </div>

                                </div>

                            </div>

                        </div>
                    )}


                </>

        </div>

        </>
    )
}

export default DarkResult